var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm-modal',{ref:"modal"},[_c('template',{slot:"body"},[_c('p',[_vm._v("Deseja realmente mudar para um plano inferior ao atual? A mudança irá se concretizar apenas para seu próximo ciclo ("+_vm._s(_vm.changeDate)+"). ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }